<template>
  <aside class="filters">
    <header class="filters-header">
      <h2 class="filters-title">{{t('Filters')}}</h2>
      <button
        v-if="hasActiveFilters"
        type="button"
        class="filters-clear"
        @click="onClearFilters"
      >
        {{ t('Clear') }}
      </button>
    </header>

    <UIAccordion
      :items="filterItems"
      :multiple="true"
      :default-open="['pricing', 'categories', 'rating']"
      class="filter-variant"
      item-key="id"
    >
      <template #header="{ item, isOpen }">
        <span class="filters-section__title">{{ typeof item === 'string' ? item : item.title }}</span>
        <span class="icon icon-chevron-down filters-section__icon" :class="{ 'is-open': isOpen }"></span>
      </template>

      <template #content-pricing>
        <Pricing @update="updatePriceFilter"/>
      </template>

      <template #content-categories>
        <Categories @update="updateCategoriesFilter"/>
      </template>

      <template #content-rating>
        <Rating @update="updateRatingFilter"/>
      </template>
    </UIAccordion>
  </aside>
</template>

<script lang="ts" setup>
import Rating from "@/components/MarketPage/Filters/Rating.vue";
import Pricing from "~/components/MarketPage/Filters/Pricing.vue";
import { computed } from 'vue';
import UIAccordion from "~/components/UIAccordion.vue";
import { useFilters } from "@/composables/useFilters";
import Categories from "~/components/MarketPage/Filters/Categories.vue";
import { useRoute } from "vue-router";

const { updateCategoriesFilter, updatePriceFilter, updateRatingFilter, clearFilters } = useFilters();
const { t } = useI18n()
const route = useRoute();

const ACTIVE_FILTER_KEYS = ['price_gte', 'price_lte', 'rating_gte', 'categories'];

const hasActiveFilters = computed(() => ACTIVE_FILTER_KEYS.some((key) => {
  const value = route.query[key as keyof typeof route.query];
  return Array.isArray(value) ? value.length > 0 : Boolean(value);
}));

const onClearFilters = () => {
  clearFilters();
};

const filterItems = [
  { id: 'pricing', title: t('Pricing') },
  { id: 'categories', title: t('Categories') },
  { id: 'rating', title: t('Rate') }
]

</script>

<style lang="scss" scoped src="./filters-style.scss"></style>
